// Eventos de Amplitude
const EVENTO_INICIO_SESION = 'LOGIN_ESIGN';
const EVENTO_TERMINAT_SESION = 'LOGOUT_SIGN';
const EVENTO_OTP = '2FA_ESING';
const EVENTO_VISTA_PDF = 'LOAD_VIEW_DOC';
const EVENTO_CARGA_PDF = 'LOAD_DOC_SIGN';
const EVENTO_TIEMPO_LECTURA = 'READ_TIME_DOC';
const EVENTO_GUARDAR_FIRMA = 'SAVE_SIGN';
const EVENTO_DESCARGA_DOC = 'DOWNLOAD_DOC';
const EVENTO_ERROR_FIRMA = 'NOT_SAVE_SIGN';
const EVENTO_CANCELAR_FIRMA = 'CANCEL_SIGN';
const EVENTO_SIN_PERMISO = 'PERMISSION_INVALID';
const EVENTO_NO_EXISTE_RECURSO = 'RESORCE_NOT_FOUND';

export default {
    EVENTO_INICIO_SESION,
    EVENTO_TERMINAT_SESION,
    EVENTO_OTP,
    EVENTO_VISTA_PDF,
    EVENTO_CARGA_PDF,
    EVENTO_TIEMPO_LECTURA,
    EVENTO_GUARDAR_FIRMA,
    EVENTO_DESCARGA_DOC,
    EVENTO_ERROR_FIRMA,
    EVENTO_CANCELAR_FIRMA,
    EVENTO_SIN_PERMISO,
    EVENTO_NO_EXISTE_RECURSO,
};
